export default __webpack_public_path__ + "static/media/telegram.baaaac61.svg";